import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import GroupReportLayer from "../../../components/Admin/GroupReportLayer";

const GroupReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <GroupReportLayer />
      </MasterLayout>
    </>
  );
};
export default GroupReport